<template>
  <router-link
    :to="localizedRoute('/')"
    :title="$t('Home Page')"
    class="no-underline inline-flex"
  >
    <img
      class="store-logo"
      :width="width"
      :height="height"
      :src="getLogo()"
      :alt="$t(defaultTitle)"
    >
  </router-link>
</template>

<script>
import config from 'config'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  props: {
    width: {
      type: [String, Number],
      required: true
    },
    height: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    const storeView = currentStoreView()
    return {
      defaultTitle: storeView.seo.defaultTitle ? storeView.seo.defaultTitle : config.seo.defaultTitle
    }
  },
  methods: {
    getLogo () {
      const storeView = currentStoreView()
      return storeView.settings.logo
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~theme/css/variables/grid";

img.store-logo {
  height: 41px;

  @include desktop {
    max-height: 60px;
    padding-right: 30px;
  }
}
</style>
